import {
  MARK_BOLD,
  MARK_ITALIC,
  MARK_UNDERLINE,
} from "@udecode/plate-basic-marks";
import { ELEMENT_PARAGRAPH } from "@udecode/plate-paragraph";
import { ELEMENT_BLOCKQUOTE } from "@udecode/plate-block-quote";
import {
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_LI,
  ELEMENT_LIC,
} from "@udecode/plate-list";

export {
  MARK_BOLD,
  MARK_ITALIC,
  MARK_UNDERLINE,
  ELEMENT_PARAGRAPH,
  ELEMENT_BLOCKQUOTE,
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_LI,
  ELEMENT_LIC,
};

export const INTENT_BOLD = MARK_BOLD;
export const INTENT_ITALIC = MARK_ITALIC;
export const INTENT_UNDERLINE = MARK_UNDERLINE;
export const INTENT_QUOTE = "quote";
export const INTENT_BULLETED_LIST = "bulletedList";
export const INTENT_NUMBERED_LIST = "numberedList";
export const INTENT_UNDO = "undo";
export const INTENT_REDO = "redo";
export const INTENT_INDENT = "indent";
export const INTENT_OUTDENT = "outdent";
export const INTENT_HIDE_KEYBOARD = "hideKeyboard";
export const INTENT_SHOW_KEYBOARD = "showKeyboard";

export const INTENT_TYPE_MARK = "mark";
export const INTENT_TYPE_BLOCK = "block";
export const INTENT_TYPE_BEHAVIOR = "behavior";

export const MAX_INDENT_LEVEL = 3;

export const DEFAULT_LABELS = {
  "textEditor.bulletedList": "Bulleted List",
  "textEditor.numberedList": "Numbered List",
  "textEditor.bold": "Bold",
  "textEditor.done": "Done",
  "textEditor.indent": "Indent",
  "textEditor.italic": "Italic",
  "textEditor.link": "Link",
  "textEditor.outdent": "Outdent",
  "textEditor.placeholder": "Write a Note...",
  "textEditor.quote": "Quote",
  "textEditor.redo": "Redo",
  "textEditor.save": "Save",
  "textEditor.underline": "Underline",
  "textEditor.undo": "Undo",
};
